import "../assets/Button.css";
import { jsxs as g, jsx as o } from "preact/jsx-runtime";
import { c as b } from "./index.2w0W-O47.js";
import { S as h } from "./Spinner.FBV1396A.js";
const T = "_button_dxonb_2 pulse-type-strong", k = "_outline_dxonb_15", I = "_primary_dxonb_38", j = "_icon_dxonb_56", v = "_isLoading_dxonb_57", A = "_iconOnly_dxonb_78", B = "_buttonText_dxonb_82", L = "_link_dxonb_89", S = "_spinner_dxonb_95", n = {
  button: T,
  outline: k,
  primary: I,
  icon: j,
  isLoading: v,
  "icon-left--1": "_icon-left--1_dxonb_62",
  "icon-right--1": "_icon-right--1_dxonb_66",
  "icon-left-0": "_icon-left-0_dxonb_70",
  "icon-right-0": "_icon-right-0_dxonb_74",
  iconOnly: A,
  buttonText: B,
  link: L,
  spinner: S
}, w = ({
  type: d = "button",
  text: s,
  label: u = "",
  level: x = "secondary",
  href: t = "",
  iconComponent: l = void 0,
  iconOnly: i = !1,
  iconPosition: c = "left",
  iconSpaceStep: p = -1,
  outline: f = !1,
  isLoading: _ = !1,
  ...e
}) => {
  const r = !t, a = () => typeof l == "object" ? /* @__PURE__ */ o(
    "span",
    {
      class: b(
        n.icon,
        !i && n[`icon-${c}-${p}`]
      ),
      children: l
    }
  ) : null, m = () => s && !i ? /* @__PURE__ */ o("span", { class: n.buttonText, children: s }) : null, y = () => _ ? /* @__PURE__ */ o(h, { class: n.spinner }) : null;
  return /* @__PURE__ */ g(
    r ? "button" : "a",
    {
      ...e,
      class: b([
        n.button,
        n[x],
        t && n.link,
        i && n.iconOnly,
        f && n.outline,
        _ && n.isLoading,
        e.class
      ]),
      href: t || void 0,
      role: t ? "button" : void 0,
      "aria-label": u || s,
      ...r && { type: d },
      children: [
        c === "left" && /* @__PURE__ */ o(a, {}),
        /* @__PURE__ */ o(m, {}),
        c === "right" && /* @__PURE__ */ o(a, {}),
        /* @__PURE__ */ o(y, {})
      ]
    }
  );
};
export {
  w as B
};
